import { api } from "@/_store/api-client";
import {
  IConfirmResetPasswordRequest,
  IConfirmResetPasswordResponse,
  ILoginRequest,
  ILoginResponse,
  IResetPasswordRequest,
  IResetPasswordResponse
} from "./contracts";

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<ILoginResponse, ILoginRequest>({
      query: (requestBody) => ({
        url: "api/v1/users/auth/login/",
        method: "POST",
        body: requestBody,
      }),
      invalidatesTags: ["Auth", "CurrentUser", "ReportHistory", "InsurancePolicy"],
    }),
    resetPassword: builder.mutation<IResetPasswordResponse, IResetPasswordRequest>({
      query: (requestBody) => ({
        url: "api/v1/users/auth/password_reset_request/",
        method: "POST",
        body: requestBody,
      }),
      invalidatesTags: ["ResetPassword"],
    }),
    confirmResetPassword: builder.mutation<IConfirmResetPasswordResponse, IConfirmResetPasswordRequest>({
      query: (requestBody) => ({
        url: "/api/v1/users/auth/password_reset_confirm/",
        method: "POST",
        body: requestBody,
      }),
      invalidatesTags: ["ConfirmResetPassword"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useLoginMutation,
  useResetPasswordMutation,
  useConfirmResetPasswordMutation,
} = authApi;
